import Control from "ol/control/Control";
import { Dispatch, SetStateAction } from "react";

class HelpControl extends Control {
  constructor(setDisplayHelpPanel: Dispatch<SetStateAction<boolean>>) {
    const button = document.createElement("button");
    button.innerHTML = "?";
    button.title = "Help";

    const element = document.createElement("div");
    element.className = "ol-help ol-unselectable ol-control";
    element.appendChild(button);

    super({
      element,
    });

    button.addEventListener(
      "click",
      () => {
        setDisplayHelpPanel(true);
      },
      false
    );
  }
}

export default HelpControl;
